import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSonnerToaster } from 'ngx-sonner';
import { VersionUpdateService } from './core/services/version-update.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, NgxSonnerToaster],
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor(private _versionUpdateService: VersionUpdateService) {}
}
